import { render } from "./Datav.vue?vue&type=template&id=6b7033e6"
import script from "./Datav.vue?vue&type=script&lang=js"
export * from "./Datav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projectAll\\cnb_2\\oulimojuxiaozhunxitong\\BOSS_GC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__